import { RadioWidget } from '../common/RadioWidget.js';

export const CategoryScreen = () => `
    <div id="category-screen" class="screen active" style="display: block !important; padding: 0 !important; width: 100% !important; max-width: 100% !important;">
        
        <!-- CSS Animation for Smooth Fade-In / Fade-Out Slider (20s Total loop, 4 images, 5s each) -->
        <style>
            @keyframes appScreenshotSlider {
                0% { opacity: 0; z-index: 1; }
                5% { opacity: 1; z-index: 5; }      /* Fade in quickly at start of turn */
                25% { opacity: 1; z-index: 5; }     /* Stay fully visible for most of the 5s */
                30% { opacity: 0; z-index: 1; }     /* Fade out gently */
                100% { opacity: 0; z-index: 1; }    /* Remain invisible for rest of loop */
            }
            .phone-slide-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                /* Use custom cubic-bezier for a premium liquid fade transition */
                transition: opacity 1.2s cubic-bezier(0.4, 0, 0.2, 1);
                animation: appScreenshotSlider 20s infinite ease-in-out;
            }
            /* Offset delay for each of the 4 images (5 seconds delay increments) */
            .phone-slide-image:nth-child(1) { animation-delay: 0s; }
            .phone-slide-image:nth-child(2) { animation-delay: 5s; }
            .phone-slide-image:nth-child(3) { animation-delay: 10s; }
            .phone-slide-image:nth-child(4) { animation-delay: 15s; }
        </style>

        <!-- SECTION 1: HOME & HERO & PHONE CAROUSEL -->
        <section id="home-section" class="clean-portal-container" style="width: 100% !important; max-width: 1200px !important; margin: 0 auto !important; padding: 40px 50px !important; min-height: calc(100vh - 85px); display: flex !important; flex-direction: row !important; align-items: center; justify-content: space-between; gap: 60px;">
            
            <!-- Left Column: Huge Phone Mockup with Screenshot Slider -->
            <div style="flex: 0 0 320px; display: flex; justify-content: center; align-items: center;">
                <div style="
                    width: 320px;
                    height: 640px;
                    background: #000;
                    border: 12px solid #1a1e29;
                    border-radius: 40px;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7), 0 0 40px rgba(0, 163, 255, 0.15);
                    position: relative;
                    overflow: hidden;
                ">
                    <!-- Notch -->
                    <div style="
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 130px;
                        height: 25px;
                        background: #1a1e29;
                        border-bottom-left-radius: 15px;
                        border-bottom-right-radius: 15px;
                        z-index: 100;
                    "></div>

                    <!-- CSS-driven Screenshots Slider (No JS required) -->
                    <div id="app-phone-slider" style="width: 100%; height: 100%; position: relative;">
                        <img src="${new URL('../../assets/images/play_screenshot_1.png', import.meta.url).href}" class="phone-slide-image">
                        <img src="${new URL('../../assets/images/play_screenshot_2.png', import.meta.url).href}" class="phone-slide-image">
                        <img src="${new URL('../../assets/images/play_screenshot_3.png', import.meta.url).href}" class="phone-slide-image">
                        <img src="${new URL('../../assets/images/play_screenshot_4.png', import.meta.url).href}" class="phone-slide-image">
                    </div>
                </div>
            </div>

            <!-- Right Column: App Info Details, Store Links, Live Radio -->
            <div style="flex: 1; display: flex; flex-direction: column; gap: 25px; justify-content: center; text-align: left; min-width: 450px;">
                <div>
                    <h1 style="font-size: 2.8rem; font-weight: 800; color: #fff; margin-bottom: 15px; line-height: 1.2; text-align: left !important;">
                        Gaddar Bilgi <br>
                        <span style="color: var(--accent-blue);">Artık Mobilde!</span>
                    </h1>
                    <p style="text-align: left !important; font-size: 1.2rem; line-height: 1.8; color: var(--text-muted); margin-bottom: 0 !important;">
                        Zekanı zorlayan, genel kültürünü test eden ve online düellolarla seni en tepeye taşıyacak Türkiye'nin en kapsamlı bilgi arenası mobil uygulamasıyla yayında. Çarkı çevir, rütbeni yükselt ve rakiplerini infaz et!
                    </p>
                </div>

                <!-- Google Play Button -->
                <div style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.05); border-radius: 12px; padding: 25px; display: flex; flex-direction: column; gap: 15px;">
                    <h4 style="color: #fff; font-size: 1.1rem; margin: 0; font-weight: 600;">Hemen Ücretsiz İndirin</h4>
                    <button class="action-btn orange-style" style="width: 100% !important; margin: 0 !important; height: 58px !important; font-size: 1.15rem !important; display: flex; align-items: center; justify-content: center; font-weight: 700 !important;" onclick="window.open('https://play.google.com/store/apps/details?id=com.gaddarbilgimobil', '_blank')">
                        MOBİL UYGULAMAYI YÜKLE
                    </button>
                </div>

                <!-- Radio Widget Card -->
                <div class="section-card" style="margin: 0 !important; padding: 25px !important; text-align: left !important;">
                    <div class="radio-widget-wrapper-local" style="width: 100%;">
                        ${RadioWidget()}
                    </div>
                </div>
            </div>
        </section>

        <!-- SECTION 2: ABOUT US -->
        <section id="about-section" style="width: 100% !important; background-color: var(--bg-header) !important; border-top: 1px solid rgba(255,255,255,0.05); border-bottom: 1px solid rgba(255,255,255,0.05);">
            <div class="clean-portal-container" style="width: 100% !important; max-width: 1200px !important; margin: 0 auto !important; padding: 80px 50px !important; text-align: left !important; display: block !important;">
                <h2 class="screen-title" style="text-align: left !important; margin-bottom: 40px !important;">HAKKIMIZDA</h2>
                
                <div style="font-size: 1.15rem; line-height: 1.9; color: var(--text-white);">
                    <h3 style="color: var(--accent-blue); margin-bottom: 20px; font-size: 1.6rem; text-align: left !important;">Gaddar Bilgi'nin Hikayesi</h3>
                    <p style="text-align: left !important; margin: 0 0 35px 0 !important; max-width: 100% !important;">
                        Bilgi, en büyük güçtür; ama sadece "Gaddar" olanlar bu gücü yönetebilir!
                        Gaddar Bilgi, sadece bir tarih platformu değil; hayatın her alanından gelen bilgiyi bir rekabet sahasına dönüştüren devasa bir arenadır. İsmi "Gaddar" çünkü bizde sorular sadece kağıt üzerinde kalmaz; zekanı, genel kültürünü ve hızını sonuna kadar zorlar.
                    </p>

                    <h3 style="color: var(--accent-blue); margin-bottom: 20px; font-size: 1.6rem; text-align: left !important;">Neden Buradayız?</h3>
                    <p style="text-align: left !important; margin: 0 0 35px 0 !important; max-width: 100% !important;">
                        İnternet dünyasındaki yüzeysel bilgilerden sıkılan, kendini her alanda geliştirmek isteyen meraklı beyinler için buradayız. gaddarbilgi.com.tr, sınırları zorlayan kategorileriyle size sadece bir oyun değil, bir öğrenme serüveni sunar.
                    </p>

                    <h3 style="color: var(--accent-blue); margin-bottom: 20px; font-size: 1.6rem; text-align: left !important;">Kategorilerimiz: Bilginin Her Rengi</h3>
                    <p style="text-align: left !important; margin: 0 0 35px 0 !important; max-width: 100% !important;">
                        Bizde tek bir yöne bakmak yok! Tarih, Coğrafya, Sosyoloji, Psikoloji, Gündem ve Online Çark gibi eğlenceli düello modlarıyla bilime ve sanata dair her şeyi mobil uygulamamızda keşfedin!
                    </p>

                    <h3 style="color: var(--accent-blue); margin-bottom: 20px; font-size: 1.6rem; text-align: left !important;">Biz Kimiz?</h3>
                    <p style="text-align: left !important; margin: 0 0 40px 0 !important; max-width: 100% !important;">
                        Biz, öğrenmeyi bir tutku, rekabeti ise bir yaşam biçimi olarak gören bir ekibiz. YouTube'daki enerjimizi şimdi web ve mobilin hızıyla birleştirerek, bilgi dünyasında "Gaddar" bir devrim yapıyoruz.
                    </p>
                </div>
            </div>
        </section>

        <!-- SECTION 3: CONTACT -->
        <section id="contact-section" style="width: 100% !important;">
            <div class="clean-portal-container" style="width: 100% !important; max-width: 1200px !important; margin: 0 auto !important; padding: 80px 50px !important; text-align: left !important; display: block !important;">
                <h2 class="screen-title" style="text-align: left !important; margin-bottom: 40px !important;">İLETİŞİM</h2>
                
                <div style="font-size: 1.15rem; line-height: 1.9; color: var(--text-white);">
                    <h3 style="color: var(--accent-blue); margin-bottom: 20px; font-size: 1.6rem; text-align: left !important;">Bizimle İletişime Geçin</h3>
                    <p style="text-align: left !important; margin: 0 0 40px 0 !important; max-width: 100% !important;">
                        Görüş, öneri, hata bildirimleri veya sponsorluk anlaşmaları için bizimle aşağıdaki e-posta adresi veya sosyal medya kanallarımız üzerinden iletişime geçebilirsiniz.
                    </p>

                    <div style="margin-bottom: 40px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.05); padding: 30px; border-radius: 12px; display: inline-block;">
                        <p style="text-align: left !important; color: var(--text-white) !important; font-size: 1.25rem !important; font-weight: 600 !important; margin-bottom: 8px !important;">📩 E-POSTA ADRESİMİZ:</p>
                        <p style="text-align: left !important; font-size: 1.5rem !important; color: var(--accent-blue) !important; font-weight: 700 !important; margin: 0 !important;">iletisim@gaddarbilgi.com.tr</p>
                    </div>

                    <div style="margin-top: 40px; display: flex; gap: 20px; justify-content: flex-start; flex-wrap: wrap;">
                        <button class="action-btn blue-style" style="margin: 0 !important;" onclick="window.open('https://instagram.com', '_blank')">INSTAGRAM</button>
                        <button class="action-btn orange-style" style="margin: 0 !important;" onclick="window.open('https://youtube.com', '_blank')">YOUTUBE KANALIMIZ</button>
                    </div>
                </div>
            </div>
        </section>

    </div>
`;
